<template>
  <!-- 底部 -->
  <div class="constitute" :style="{'backgroundColor': background}">
    <div>
      <div class="title">{{ title }}</div>
      <div class="content" :class="{'contentThree' : constitute.length == 3}">
        <div class="list" v-for="item of constitute" :key="item.title">
          <img :src="item.img" alt="" />
          <div class="headline">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
          <div class="nopx-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    constitute: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: function() {
    return {
      data: {
        menu_list: []
      }
    };
  },
  created() {},
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.constitute {
  background-image: url(~@/assets/images/background.png);
  background-size: 100% 100%;
  > div {
    width: 1200px;
    // height: 738px;
    padding-bottom: 100px;
    margin: 0 auto;
    overflow: hidden;
    .title {
      text-align: center;
      margin-top: 161px;
      line-height: 1;
      font-size: 42px;
      font-weight: bold;
      color: #ffffff;
    }
    .content {
      display: flex;
      overflow: hidden;
      .list {
        width: 25%;
        flex: 1;
        // height: 398px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 45px;
        padding-top: 60px;
        box-sizing: border-box;
        > img {
          width: 87px;
          height: 87px;
          display: block;
        }
        .headline {
          font-size: 28px;
          font-weight: 500;
          color: #ffffff;
          line-height: 1.5;
          margin-top: 27px;
          text-align: center;
          & + div {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 1.5;
            margin-top: 10px;
            word-break:break-all;
          }
        }
        .desc {
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 1;
          margin-top: 24px;
        }
        .nopx-line {
          width: 1px;
          height: 100%;
          position: absolute;
          top: 0;
          right: -1px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0),
            #fff,
            rgba(255, 255, 255, 0.1)
          );
        }
        &:last-child .nopx-line {
          display: none;
        }
        // &::after {
        //   content: "";

        // }
      }
    }
    .more {
      width: 209px;
      height: 47px;
      border-radius: 24px;
      border: 1px solid #ffffff;
      margin: 0 auto;
      margin-top: 18px;
      text-align: center;
      line-height: 47px;
      font-size: 32px;
      font-weight: 300;
      color: #ffffff;
    }
  }
}
@media (max-width: 1000px) {
  div.constitute{
    background-image: url(~@/assets/images/background.png);
    background-size: 100%;
    background-repeat: no-repeat;
    > div{
      width: 100%;
      height: auto;
      padding-bottom: 0;
      .title{
        margin-top: 120px;
        font-size: 44px;
      }
      .content{
        background: #F27529;
        padding: 0 48px;
        padding-top: 1px;
        padding-bottom: 16px;
        flex-wrap: wrap;
        margin-top: 70px;
        .list{
          width: 50%;
          flex: auto;
          padding: 0;
          img{
            width: 100px;
            height: auto;
          }
          .headline{
            font-size: 36px;
          }
          .desc{
            width: 264px;
            font-size: 28px;
            margin-bottom: 84px;
            text-align: justify;
          }
          .nopx-line{
            display: none;
          }
        }
      }
      .contentThree{
        display: block;
        .list{
          width: 100%;
          .desc{
            width: 506px;
            font-size: 28px;
            margin-bottom: 100px;
            text-justify: inherit;
          }
        }
      }
    }
  }
}
</style>
